import { IntlFormatters, useIntl as useReactIntl } from "react-intl";
import { translationKeys } from "./translationMap";

type FormatMessageArgs = Parameters<IntlFormatters["formatMessage"]>;

export function useIntl() {
  // Pull out the original formatMessage function.
  const { formatMessage, ...rest } = useReactIntl();

  // Re-write the formatMessage function but with a strongly-typed id.
  const typedFormatMessage = (
    descriptor: FormatMessageArgs[0] & {
      id?: translationKeys;
    },
    values?: FormatMessageArgs[1],
    options?: FormatMessageArgs[2]
  ) => {
    return formatMessage(
      descriptor,
      values as Record<string, any> | undefined,
      options
    ) as string;
    // TODO: Unfotunately a yarn upgrade caused the regular usage of this function
    // in component props (e.g. <div label={{formatMessage(...)}}) to error out because
    // these props expect strings, but the library is casting the result as a ReactNode.
    // To fix we need to cast the result to a string.
    // Future improvement here would be to guarantee it always returns a string and not a
    // React component.
  };

  return {
    ...rest,
    formatMessage: typedFormatMessage,
  };
}
